// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'journal-entry.page.create.title': 'Create Journal Entries',

    'journal-entry.button.cancel': 'Cancel',
    'journal-entry.button.save': 'Save Entries',
    'journal-entry.button.add': 'Add Entry',
    'journal-entry.button.create': 'New Entry',

    'journal-entry.link.create_first_journal_entry': 'Click here to create your first journal entry',
    'journal-entry.link.retry': 'Click here to retry',

    'journal-entry.label.debit': 'Debit',
    'journal-entry.label.credit': 'Credit',
    'journal-entry.label.journal_entry_batch_name': 'Journal Entry Batch',
    'journal-entry.label.general_ledger_account': 'General Ledger Account',
    'journal-entry.label.entity_name': 'Contact',
    'journal-entry.label.journal_entry_date': 'Entry Date',
    'journal-entry.label.memo': 'Memo',

    'journal-entry.success.message.journal_entry_created': 'Your journal entries have been recorded',

    'journal-entry.error.message.unbalanced': 'Total Debits must equal Total Credits',
    'journal-entry.error.message.error_loading_page': 'Sorry, there was an error loading journal entry.| Sorry, there was an error loading journal entries.',

    'journal-entry.modal.title.journal-entry-save': 'Save Journal Entries',
    'journal-entry.modal.message.journal-entry-save':
        'Manual data entry can be risky and may lead to errors. Please confirm that you understand the implications. If you are unsure, we recommend seeking expert advice first.<br/> <br/> Do you want to proceed?',
    'journal-entry.button.confirm': 'Confirm',
};
